/**
 * Проекты, чей id выдал клиент, а создание на сервере ещё в пути (черновик открывается сразу, POST идёт в фоне).
 * Запросы к такому проекту ждут создания (api/client.ts): иначе сервер ответил бы 404 на правку, файл или discard.
 */
import { createInFlightTracker } from './inFlightByKey';

const creates = createInFlightTracker();

/** Путь вида /projects/<id>[/…|?…]: id проекта, к которому запрос */
const PROJECT_PATH = /^\/projects\/([^/?#]+)/;

/** Отмечает создание проекта на время промиса; ошибка промиса — тому, кто создание начал. */
export function trackProjectCreate<T>(projectId: string, create: Promise<T>): Promise<T> {
  return creates.track(projectId, create);
}

export function isProjectCreatePending(projectId: string): boolean {
  return creates.has(projectId);
}

/**
 * Ожидание для запроса по пути API: проект ещё создаётся — промис, иначе null (запрос уходит без лишнего тика).
 * Само создание (/projects/drafts) сюда не попадает: «drafts» — не id создаваемого проекта.
 */
export function pendingProjectCreateFor(path: string): Promise<void> | null {
  const projectId = PROJECT_PATH.exec(path)?.[1];
  return projectId && creates.has(projectId) ? creates.wait(projectId) : null;
}
